import { Container } from 'react-bootstrap'
import styled from "styled-components";

export default styled(Container)`
  padding-top: 24px;
  padding-bottom: 24px;
`
